import React, { useEffect } from "react";
import "./Contact.css";
import ContactInfo from "./ContactInfo"
import { ToastContainer, toast } from "react-toastify";
// import emailjs from "@emailjs/browser";
// import Aos from "aos";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact Us";
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "ee8fa2ec-efa3-4347-a8ac-cbc23c369239");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      toast.success('Login successfully', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        // transition: Bounce,
        });
    }
  };

  return (
    <>
      <div className="container-fluid bg-img-111">
        <div className="hero-text">
          <h1 className="title text-center">CONTACT US</h1>
        </div>
      </div>
      <ContactInfo />

      <section className="contact " id="contact">
        <div className="container text-center registration-container">
          <div className="col-sm-12 col-lg-12 text-center">
            <form onSubmit={onSubmit}>
              {/* onSubmit={handleSubmit} */}
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Name"
                    id="name"
                    name="name"
                    // value={formData.name}
                    // onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    id="email"
                    name="email"
                    //  value={formData.email}
                    //  onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-sm-6">
                  <input
                    className="form-control"
                    type="tel"
                    id="phone"
                    placeholder=" (+44-123-456-7890)"
                    name="phone"
                    // value={formData.phone}
                    // onChange={handleChange}
                    required
                  />
                </div>

                <div className="col-sm-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    id="subject"
                    name="name"
                    //  value={formData.subject}
                    //  onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                {/* id="comment" */}
                <textarea
                  className="form-control"
                  rows={5}
                  placeholder="Message"
                  id="message"
                  name="message"
                  //  value={formData.message}
                  //  onChange={handleChange}
                  required
                />
                {/* defaultValue={""} */}
              </div>
              <button className="btn btn-block" type="submit">
                Send Now!
              </button>
            </form>
          </div>
        </div>
        <ToastContainer />
      </section>
    </>
  );
};

export default Contact;
